import { Button, Modal } from 'antd';
import React, { useState } from 'react';

type Props = {
    title: string;
    howToFix: string;
    howToFixVideo?: string;
};

export default function HowToFix({ title, howToFix, howToFixVideo }: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    return (
        <div className="description-meta">
            <Button
                type="danger"
                onClick={toggleModal}
            >
                How to fix
            </Button>

            <Modal
                centered
                className="wide-modal"
                title={title}
                visible={isModalVisible}
                onCancel={toggleModal}
                footer={null}
            >
                <div className="modal-content no-padding">
                    {howToFixVideo && (
                        <iframe
                            title="video"
                            width="100%"
                            height="320"
                            src={howToFixVideo}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    )}
                    <div className="default-padding how-to-fix-content">
                        <h3>How to pass this test?</h3>
                        <div dangerouslySetInnerHTML={{ __html: howToFix }} />
                    </div>
                </div>
                <div className="button-footer">
                    <Button
                        //@ts-ignore
                        type="secondary"
                        onClick={toggleModal}
                    >
                        Close
                    </Button>
                </div>
            </Modal>
        </div>
    );
}
